/*
 * @Author: dengyong dengyong@caohua.com
 * @Date: 2022-08-10 14:51:58
 * @LastEditors: dengyong dengyong@caohua.com
 * @LastEditTime: 2022-08-10 14:52:04
 * @FilePath: /tiangong/src/views/tools/toutiaoGameConfig.vue/mixin.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

export default {
  methods: {
    changePageIndex (index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize (size) {
      this.setLocalPage(size) // 设置常用页码
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    searchFilterData (params) {
      this.pageIndex = 1
      this.getData(params)
    },
    filterData (params) {
      this.pageIndex = 1
      this.getData(params)
    }
  },
  data () {
    return {
      loading: null,
      tableLoading: null,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      tableList: [],
      tableCol: []
    }
  }
}
